import { FormInputRow, Input } from '@emerald-works-nova/components'
import { Box, CircularProgress, FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'
import { Controller } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { TemplateListSlice } from '../../../reducers'
import { useTemplateFormContext } from '../template-form-context'
import { useStyles } from './style'

const DetailTab = () => {
  const classes = useStyles()
  const { form, isEdit, template, parentTemplate, isLoading } = useTemplateFormContext()
  const { control, setValue, formState: { errors } } = form
  const selectIsFetchingTemplateList = useSelector(TemplateListSlice.selectors.selectIsFetchingTemplateList)
  const templates = useSelector(TemplateListSlice.selectors.selectTemplateListSelect)

  React.useEffect(() => { parentTemplate && setValue('parent', parentTemplate.sk) }, [parentTemplate, setValue])

  const TemplateBaseInput = () => {
    if (isEdit) {
      const parentTemplate = templates.find(t => t.sk === template.parent?.sk)
      const baseName = parentTemplate?.name || 'Template Base'
      return (
        <Input
          label={baseName}
          name='base'
          control={control}
          disabled
        />
      )
    }

    if (!templates.length && selectIsFetchingTemplateList && !isLoading) {
      return (
        <Box display='flex' justifyContent='center'>
          <CircularProgress size={20} color='primary' />
        </Box>
      )
    }

    return (
      <Controller
        name='parent'
        control={control}
        render={({ field }) => (
          <FormControl variant='outlined' className={classes.selectControl}>
            <InputLabel id='template-base-select-lbl'>Template Base</InputLabel>
            <Select
              variant='outlined'
              {...field}
              id='template-base-select'
              labelId='template-base-select-lbl'
              value={field.value?.sk || field.value || ''}
            >
              <MenuItem value=''><em>None</em></MenuItem>
              {templates?.map(template => <MenuItem value={template.sk} key={template.sk}>{template.name}</MenuItem>)}
            </Select>
          </FormControl>
        )}
      />
    )
  }

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={12}>
          <FormInputRow
            title='Template Name'
            description='This is the template name. '
            InputComponent={
              <Input
                autoFocus
                disabled={isLoading}
                rules={{ required: true }}
                label='Name'
                name='name'
                control={control}
                valid={errors.name === undefined}
                error='Template Name is required'
                showErrors
              />
            }
          />
        </Grid>
        <Grid item xs={12}>
          <FormInputRow
            title='Template Base'
            description='Select one of the predefined templates from the list on the side as a basis for creating the New Template.'
            InputComponent={<TemplateBaseInput />}
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default DetailTab
